import * as React from 'react';
import { TabularList } from './TabularList';

export interface IResourceTabularListField<T> {
  key: keyof T;
  label: string;
}

export interface IResourceTabularList<T> {
  fields: IResourceTabularListField<T>[];
  resource: T;
}
/**
 * Try not to use this component
 * IMO it adds unneeded complexity - just build the list manually when you need to and use a TabularList
 */
export function ResourceTabularList<T>(props: IResourceTabularList<T>) {
  const { fields, resource } = props;

  const items = fields.map(({ key, label }) => {
    const value = resource[key as string];
    return { label, value };
  });

  return <TabularList {...{ items }} />;
}
